
/* Common: ADI Handler */
ADILF.define('adilf/handler',[
        'require',
        'streamhub-sdk/jquery', 
        'adilf/context', 
        'adilf/debug'
    ], function(require, jquery, Context, Debug) {

    "use strict";

    var _instance = null;

    var _getInstance = function() {
        if (!_instance) {
            _instance = new Handler();
        }
        return _instance;
    };

    var Handler = function() {
        var self = this;
        /* istanbul ignore next */
        if(_instance !== null) { return; }
        self.init();
    };

    Handler.prototype.debug = new Debug("Advance.Social.handler");

    Handler.prototype.init = function() {
        this.apps = {};
        this.reqNamespace = "ADILF";
        this.shims = {};
        this.eventSubscriptions = {};
        this.beaconElName = 'adilf';
        this.beaconElSelector = '#'+this.beaconElName;
    };

    Handler.prototype.appExists = function(appName) {
        var self = this;
        return !!this.apps[appName];
    };

    Handler.prototype.getApp = function(appName) {
        var self = this;
        return appName in self.apps ? self.apps[appName] : false;
    };

    Handler.prototype.addApp = function(config, callback) {
        var self = this;
        if(!config) { throw new Error("Config required"); }
        if(!config.module) { throw new Error("Module required"); }
        if(config.conf && config.conf.name && config.conf.name != config.name) {
            if(config.name !== undefined) {
                self.debug.warn("addApp: names do not match:", config.conf.name, config.name, "Using "+config.conf.name);
            }
            config.name = config.conf.name;
        }
        if(config.conf && !config.conf.name) { config.conf.name = config.name; }
        if(!config.name) { throw new Error("Name required"); }
        require([config.module], function(Thing) {
            var app = new Thing(config.conf);
            if(!self.apps[config.name]) {
                self.apps[config.name] = app;
                self.debug.print("Added " + config.name + " to handler.apps");
            }
            if (typeof callback === "function") { callback(); }
        });
    };

    Handler.prototype.removeApp = function(appName) {
        var self = this;
        if(self.apps[appName]) {
            if(typeof self.apps[appName].destroy === 'function') { self.apps[appName].destroy(); }
            delete self.apps[appName];
            return true;
        }
        return false;
    };

    Handler.prototype.shimCSS = function(conf) {
        var self = this;
        if(!conf || !conf.href) { throw new Error("href required"); }
        if(!conf.name) { conf.name = conf.href; }
        if(!self.shims[conf.name]) {
            self.debug.print("Fetching remote CSS", conf.name);
            var link = document.createElement("link");
            link.type = "text/css";
            link.rel = "stylesheet";
            link.href = conf.href;
            if(conf.id) { link.id = conf.id; }
            document.getElementsByTagName("head")[0].appendChild(link);
            self.shims[conf.name] = true;
        } else {
            self.debug.print("CSS already shimmed", conf.name);
        }
    };

    Handler.prototype.subscribe = function(eventName, callback, caller) {
        this.debug.print("New subscriber:", eventName, callback, caller);
        /* istanbul ignore if */
        if(!eventName || typeof callback !== 'function') { return; }

        if(!this.eventSubscriptions[eventName]) { this.eventSubscriptions[eventName] = []; }
        /* istanbul ignore else */
        if(!caller) { caller = "unknown"; }
        this.eventSubscriptions[eventName].push({ caller: caller, callback: callback });

        if([ window.jQuery.fn.jquery.split(".")[0], window.jQuery.fn.jquery.split(".")[1] ].join("") > 16) {
            // jQ >=1.7
            window.jQuery(this.beaconElSelector).on(eventName, callback);
        } else {
            // old jQ
            window.jQuery(document).delegate(this.beaconElSelector, eventName, callback);
        }
    };

    Handler.prototype.unsubscribe = function(eventName, callback) {
        /* istanbul ignore if */
        if(!eventName || !callback) { return; }

        if([ window.jQuery.fn.jquery.split(".")[0], window.jQuery.fn.jquery.split(".")[1] ].join("") > 16) {
            // jQ >=1.7
            window.jQuery(this.beaconElSelector).off(eventName, callback);
        } else {
            // old jQ
            window.jQuery(document).undelegate(this.beaconElSelector, eventName, callback);
        }
    };

    Handler.prototype.broadcast = function(opts) {
        /* istanbul ignore if */
        if(!opts.eventName) { return; }
        opts.elementSelector = opts.elementSelector || this.beaconElSelector;
        opts.data = opts.data || {};
        window.jQuery(opts.elementSelector).trigger(opts.eventName, opts.data);
    };

    /* Begin: Legacy Echo API methods to Livefyre methods */
    Handler.prototype.scrapeCommentCounters = 
    Handler.prototype.refreshCommentCounters = function(callback) {
        var self = this;
        if(self.apps.CommentCount) {
            self.apps.CommentCount.refresh(callback);
        }
    };

    Handler.prototype.bpLogout =
    Handler.prototype.bpSessionSync = function() {};
    /* End: Legacy Echo API methods to Livefyre methods */

    Handler.prototype.getInstance = _getInstance;

    window.Advance.Social.handler = _getInstance();

    // legacy Echo namespace
    window.Advance.Echo = window.Advance.Social;

    // Create and define lfHandlerReady  event.
    var event = document.createEvent('Event');
    event.initEvent('lfHandlerReady', true, true);
    window.dispatchEvent(event);
    Handler.prototype.debug.print("lfHandlerReady event fired");

    return _getInstance();

});